
































import { Vue, Component } from "vue-property-decorator"

import OldPage from "@/components/Page.vue"
import NewPage from "@/components/New/Page/Page.vue"
import { Getter } from "vuex-class"

/**
 * @summary Page Wrapper component which provides a backwards-compatible way of updating pages within Cases
 * to use the new style components.
 *
 * If the user has the V2 interface switched on, the new page component (along with the new header bar and
 * sidebar) will be used.
 *
 * If the user does not have the V2 interface switched on, the old page component will be used instead.
 */
@Component({
	components: {
		"old-page": OldPage,
		"new-page": NewPage
	}
})
export default class PageWrapper extends Vue {
	/**
	 * @summary Getter which returns a value indicating whether the user has the V2 interface enabled.
	 */
	@Getter("getUseV2")
	shouldUseNewInterface!: boolean;

	get newUi (): boolean {
		return this.shouldUseNewInterface
	}
}
